// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'lib-flexible/flexible';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueDialog from '@/components/vueDialog.vue';
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
import store from './store';
import 'swiper/swiper-bundle.css'
import _ from 'lodash';
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

Vue.component("vueDialog", vueDialog);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js